import React from 'react';
import {
  IBilledByDayData,
  IBilledByDayProduct
} from '../../../../../store/ducks/dashboard/types';
import { formatNumberTon } from '../../../../../utils/formatNumbers';
import { Table } from '@gerdau/hefesto-mais-web';

interface IBilledByDayChartProps {
  data: IBilledByDayData[];
  allProductsDescription: string[];
}

interface ITotalsRow {
  key: number;
  productType: string;
  total: string;
}

const BilledByDayTable: React.FC<IBilledByDayChartProps> = ({
  data,
  allProductsDescription
}) => {
  const getColumns = () => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const columns: any = [
      {
        title: <b>Tipo de produto</b>,
        dataIndex: 'productType',
        fixed: 'left' as const,
        render: (text: string) => <>{text}</>
      },
      {
        title: <b>Total</b>,
        dataIndex: 'total',
        fixed: 'left' as const,
        align: 'center' as const,
        render: (text: string) => <>{text}</>
      }
    ];

    data.forEach((item) => {
      columns.push({
        title: item.date,
        dataIndex: item.date,
        align: 'center' as const,
        render: (text: string) => <>{text}</>
      });
    });

    return columns;
  };

  const tableData: ITotalsRow[] = [];

  let totalsRow = {
    key: 0,
    productType: 'Total diário',
    total: formatNumberTon(
      data
        .reduce(
          (acc, curr) =>
            curr.products.reduce(
              (accProductsSum: number, currProduct: IBilledByDayProduct) =>
                currProduct.billedToday + accProductsSum,
              0
            ) + acc,
          0
        )
        .toFixed(3)
    )
  };
  data.forEach((item) => {
    totalsRow = {
      ...totalsRow,
      [item.date]: formatNumberTon(
        item.products
          .reduce(
            (accProductsSum: number, currProduct: IBilledByDayProduct) =>
              Number((currProduct.billedToday + accProductsSum).toFixed(3)),
            0
          )
          .toString()
      )
    };
  });
  tableData.push(totalsRow);

  allProductsDescription.forEach((productDescription, idx) => {
    let row = {
      key: idx + 1,
      productType: productDescription,
      total: formatNumberTon(
        data
          .reduce(
            (acc, curr) =>
              acc +
              (curr.products.find(
                (i: IBilledByDayProduct) =>
                  i.divisionDescription === productDescription
              )?.billedToday || 0),
            0
          )
          .toFixed(3)
      )
    };

    data.forEach((item) => {
      row = {
        ...row,
        [item.date]: formatNumberTon(
          item.products
            .find(
              (i: IBilledByDayProduct) =>
                i.divisionDescription === productDescription
            )
            ?.billedToday.toFixed(3) || '0'
        )
      };
    });

    tableData.push(row);
  });

  return (
    <Table
      scroll={{
        x: true
      }}
      columns={getColumns()}
      dataSource={tableData}
    />
  );
};

export default BilledByDayTable;
